import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Banner from 'yoda-core-components/lib/components/Banner/Banner';
import { checkUrlExtension, replaceSubdomain } from 'yoda-core-components/lib/helpers/Utils/Utils';
import isEmpty from 'lodash/isEmpty';
import RichText from '../../../RichText/RichText';
import * as styles from './DetailShort.css';

const cx = classNames.bind(styles);

const DetailShort = ({ customClass, inspirationDetails, preferences }) => {
    if (isEmpty(inspirationDetails)) {
        return null;
    }
    const { headline = '', subHeadline = '', media = {} } = inspirationDetails;
    const { url = '', altText = '' } = media || {};

    const imageExt = checkUrlExtension(url);
    const convUrl = replaceSubdomain(url, preferences);

    return (
        <div className={cx('renderContentInfoBlock', customClass)} id="inspirational-block">
            {imageExt === 'mp4' ? (
                <video playsInline autoPlay muted loop width="100%" height="100%">
                    <source
                        src={convUrl}
                        type="video/mp4"
                        ariaLabel={altText}
                        automationId="fitFinder-modal-image"
                        altText={altText}
                    />
                </video>
            ) : (
                <div className={cx('renderContentImageBlock')}>
                    {' '}
                    <Banner
                        ariaLabel={altText}
                        automationId="fitFinder-modal-image"
                        bannerImageUrl={url}
                        bannerClass={cx('detailBananerImageBlock')}
                        bannerImageClass={cx('detailBannerImage')}
                        altText={altText}
                    />{' '}
                </div>
            )}

            <div className={cx('renderContentInfo')}>
                <h3 data-automation-id="fit-finder-title" className={cx('fitFinderTitle')}>
                    <RichText text={headline} />
                </h3>
                <h4 data-automation-id="fit-finder-desc" className={cx('fitFinderDesc')}>
                    <RichText text={subHeadline} />
                </h4>
            </div>
        </div>
    );
};

DetailShort.defaultProps = {
    customClass: '',
    inspirationDetails: {},
};

DetailShort.propTypes = {
    preferences: PropTypes.objectOf(PropTypes.object).isRequired,
    customClass: PropTypes.string,
    inspirationDetails: PropTypes.object,
};

export default DetailShort;
